const spacing = {
  0: 0,
  12: 1,
  25: 2,
  50: 4,
  100: 8,
  200: 12,
  300: 16,
  400: 24,
  500: 32,
  600: 40,
  700: 64,
  800: 80,
  900: 100,
  1000: 120,
  1100: 160,
  1200: 200,
};

export { spacing };
